import "webdatarocks/webdatarocks.css";
import React, { useEffect, useRef, useState } from "react";
import { useDarkModeStore } from "../../../store/useDarkModeStore";
import { useLanguageStore } from "../../../store/useLanguageStore";
import WebDataRocks from "webdatarocks";
import LoadingRaport from "./LoadingRaport";
import useTickets from "../../../store/ReactQueries/tickets/useTicket";

const rowsName = ["Title", "Description", "Customer", "Intervention Type", "Location", "Category", "Priority", "Status", "Assigned To", "Department", "Contractor", "Due Date", "Is Recurring", "Created Date", "Updated Date"];

const TicketRaports = () => {
  const pivotRef = useRef<HTMLDivElement>(null);
  const { language } = useLanguageStore();
  const { darkMode } = useDarkModeStore();
  const { data: tickets, isLoading: loadingTicket, error: ticketErrors } = useTickets(0, 0);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (pivotRef.current && tickets && !loadingTicket && !ticketErrors) {
      setLoading(true);

      const ticketsData = tickets?.map((ticket) => ({
        Title: ticket.title,
        Description: ticket.description,
        Customer: ticket.customer?.title,
        "Intervention Type": ticket.interventionType?.title,
        Location: ticket.location?.title,
        Category: ticket.category?.title,
        Priority: ticket.priority?.title,
        Status: ticket.status?.title,
        "Assigned To": ticket.assignedTo ? `${ticket.assignedTo?.firstname} ${ticket.assignedTo?.lastname}` : language['NotAssigned'],
        Department: ticket.department.title,
        Contractor: ticket.contractor?.title,
        "Due Date":
          ticket.dueDate && new Date(ticket.dueDate).toLocaleDateString(),
        "Is Recurring": ticket.isRecurring ? language['Yes'] : language['No'],
        "Created Date":
          ticket.createdDate &&
          new Date(ticket.createdDate).toLocaleDateString(),
        "Updated Date":
          ticket.updatedDate &&
          new Date(ticket.updatedDate).toLocaleDateString(),
      }));

      const pivot = new WebDataRocks({
        container: pivotRef.current,
        toolbar: true,
        height: "100%",
        width: "100%",
        report: {
          dataSource: { data: ticketsData },
          options: {
            grid: {
              type: "flat",
              showTotals: "off",
              showGrandTotals: "off",
            },
          },
          slice: {
            rows: rowsName.map(uniqueName => ({ uniqueName })),
            columns: [],
            measures: [],
          },
        },
        reportcomplete: () => {
          setTimeout(() => {
            setLoading(false);
          }, 500)
        },
      });
    }
  }, [tickets, loadingTicket, ticketErrors, darkMode]);


  return (
    <div className="mb-4" style={{ height: "83vh", position: "relative" }}>
      {loading && <LoadingRaport />}
      <div ref={pivotRef} />
    </div>
  );
};

export default TicketRaports;
